<template>
  <span>
    <b-button
      class="text-uppercase float-right ml-1 mb-1"
      size="sm"
      @click.prevent="showMermaModal()"
      >Merma</b-button
    >
    <b-button
      class="text-uppercase float-right ml-1 mb-1"
      size="sm"
      @click.prevent="showOperationalModal()"
      >brecha op</b-button
    >

    <b-button
      class="text-uppercase float-right ml-1 mb-1"
      size="sm"
      @click.prevent="showSquareModal()"
      v-if="$route.params.process_type === 'ENMALLADO'"
      >brecha com</b-button
    >

    <b-button
      @click.prevent="showReturnModal()"
      class="text-uppercase float-right ml-1 mb-1"
      size="sm"
      >Devolución</b-button
    >
    <b-button
      @click.prevent="showModal(false)"
      class="text-uppercase float-right ml-1 mb-1"
      size="sm"
      >Otros</b-button
    >

    <b-button
      @click.prevent="showModal(true)"
      class="text-uppercase float-right ml-1 mb-1"
      size="sm"
    >
      <i class="fa fa-plus pr-1" />{{ $route.params.process_type }}
    </b-button>

    <create-content
      class="float-right"
      :products_url="products_url"
      :lot="lot"
      :lot_id="lot_id"
      :product_id="product_id"
      :product_name="product_name"
      :net_kilograms_sum_in="net_kilograms_sum_in"
      :net_kilograms_sum_out="net_kilograms_sum_out"
      :modal="modal"
      @hideModal="hideModal"
    />

    <create-content-devolution
      class="float-right"
      :lot="lot"
      :lot_id="lot_id"
      :product_id="product_id"
      :product_name="product_name"
      :net_kilograms_sum_in="net_kilograms_sum_in"
      :net_kilograms_sum_out="net_kilograms_sum_out"
      :modal="modalReturn"
      @hideReturnModal="hideReturnModal"
    />

    <create-content-brecha-comercial
      class="float-right"
      :lot="lot"
      :lot_id="lot_id"
      :fruit_id="fruit_id"
      :product_id="product_id"
      :product_name="product_name"
      :product_code="product_code"
      :net_kilograms_sum_in="net_kilograms_sum_in"
      :net_kilograms_sum_out="net_kilograms_sum_out"
      :modal="modalSquare"
      @hideSquareModal="hideSquareModal"
    />

    <create-content-brecha-operacional
      class="float-right"
      :lot="lot"
      :lot_id="lot_id"
      :fruit_id="fruit_id"
      :product_id="product_id"
      :product_name="product_name"
      :product_code="product_code"
      :net_kilograms_sum_in="net_kilograms_sum_in"
      :net_kilograms_sum_out="net_kilograms_sum_out"
      :modal="modalOperational"
      @hideOperationalModal="hideOperationalModal"
    />

    <create-content-merma
      class="float-right"
      :lot="lot"
      :lot_id="lot_id"
      :fruit_id="fruit_id"
      :product_id="product_id"
      :product_name="product_name"
      :product_code="product_code"
      :net_kilograms_sum_in="net_kilograms_sum_in"
      :net_kilograms_sum_out="net_kilograms_sum_out"
      :modal="modalMerma"
      @hideMermaModal="hideMermaModal"
    />
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import CreateContent from "./CreateContent";
import CreateContentDevolution from "./CreateContentDevolution";
import CreateContentBrechaComercial from "./CreateContentBrechaComercial";
import CreateContentMerma from "./CreateContentMerma";
import CreateContentBrechaOperacional from "./CreateContentBrechaOperacional";

export default {
  name: "CreateContentButtons",
  components: {
    CreateContent,
    CreateContentDevolution,
    CreateContentBrechaComercial,
    CreateContentMerma,
    CreateContentBrechaOperacional
  },
  props: {
    lot: {
      type: String,
      default: ""
    },
    net_kilograms_sum_in: {
      type: String,
      default: 0
    },
    net_kilograms_sum_out: {
      type: String,
      default: 0
    },
    lot_id: {
      type: Number,
      default: 0
    },
    fruit_id: {
      type: Number,
      default: 0
    },
    product_id: {
      type: Number,
      default: 0
    },
    product_name: {
      type: String,
      default: 0
    },
    product_code: {
      type: String,
      default: 0
    }
  },
  data() {
    return {
      products_url: "",
      modal: false,
      modalReturn: false,
      modalSquare: false,
      modalMerma: false,
      modalOperational: false
    };
  },
  computed: {
    ...mapGetters("bagnoProcessModule", [
      "countIn",
      "countOut",
      "differenceNet",
      "checkBrechaComercial"
    ])
  },
  methods: {
    showModal(process_type) {
      this.modal = true;
      this.changeProductFilter("/bagno/product/select_product/", process_type);
    },
    hideModal() {
      this.modal = false;
    },
    showReturnModal() {
      this.modalReturn = true;
    },
    hideReturnModal() {
      this.modalReturn = false;
    },
    showSquareModal() {
      this.modalSquare = true;
    },
    hideSquareModal() {
      this.modalSquare = false;
    },
    showMermaModal() {
      this.modalMerma = true;
    },
    hideMermaModal() {
      this.modalMerma = false;
    },
    showOperationalModal() {
      this.modalOperational = true;
    },
    hideOperationalModal() {
      this.modalOperational = false;
    },
    changeProductFilter(url, process_type) {
      let filter = "";
      if (process_type) {
        filter =
          this.$route.params.process_type === "ENMALLADO"
            ? "?packing_type=1"
            : "";
      }
      this.products_url = url + filter;
    }
  }
};
</script>

<style scoped></style>
